//============================
//# mmbokaccno
//============================

export default interface Ledger {
    accNo: string | null;
    name: string;
}

export const LedgerDefaultProps: Ledger = {
    accNo: null,
    name: ""
}